import { useState, useEffect, } from 'react';
import {
	Column,
	Row,
	Text,
} from 'native-base';
import oneHatData from '@onehat/data';
import Combo from '@onehat/ui/src/Components/Form/Field/Combo/Combo.js';
import _ from 'lodash';


export default function AddConnection(props) {
	const {
			excludedUsernames,
			onAddConnection,
		} = props,
		[isReady, setIsReady] = useState(false),
		ChatRecipients = oneHatData.getRepository('ChatRecipients'),
		onChangeValue = (id) => {
			const chatRecipient = ChatRecipients.getById(id);
			onAddConnection(chatRecipient);
		};

	useEffect(() => {
		if (ChatRecipients.isDestroyed) {
			return; // for auto-reload of Expo
		}
		
		(async () => {

			// NOTE: don't forget that we're also setting other baseParams in setUserThunk
			ChatRecipients.filter('recipients__username NOT IN', excludedUsernames);
			await ChatRecipients.load();

			setIsReady(true);
		})();

	}, [excludedUsernames]);

	if (!isReady) {
		return null;
	}

	return <Column
				flex={1}
				w="100%"
				alignItems="center"
				justifyContent="center"
				safeArea
			>
				<Text mb={4} textAlign="center">Please select a client to chat with:</Text>
				<Row>
					<Combo
						Repository={ChatRecipients}
						onChangeValue={onChangeValue}
						loadAfterRender={false}
					/>
				</Row>
			</Column>;
}
